import {z} from 'zod';

export const userPreferences = z.object({
    frontstageNavigationCollapsed: z.boolean(),
    adminNavigationCollapsed: z.boolean(),
    adminDesklyConnectPreview: z.boolean(),
    newBooking: z.boolean(),
    showNewBookingHint: z.boolean(),
    showNewBookingTutorialHint: z.boolean(),
    showNewBookingTutorialVideo: z.boolean(),
    resourceHintCloseCount: z.number().int(),
});

export type UserPreferences = z.infer<typeof userPreferences>;
